import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'The Orbital Ledger';
const DEFAULT_DESCRIPTION = 'Track inventory, plan trade routes, manage your org, and dominate the market in Star Citizen. Free community tools for every citizen.';
const BASE_URL = 'https://theorbitalledger.com';

/**
 * Per-page SEO meta tags. Overrides the static defaults in index.html.
 *
 * @param {string} title   - Page title (appended with " | The Orbital Ledger")
 * @param {string} description - Page meta description (max ~160 chars)
 * @param {string} path    - URL path (e.g. "/faq") for canonical + og:url
 */
const DEFAULT_IMAGE = `${BASE_URL}/orbital-ledger-og.png`;

const SEOHead = ({ title, description = DEFAULT_DESCRIPTION, path = '', image }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Star Citizen Companion`;
  const url = `${BASE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
    </Helmet>
  );
};

export default SEOHead;
